// DO NOT EDIT BY HAND — populated by: npm run extract-letterform

import type { LetterMasters } from '@/types/letterform'

export const letterCHEVRON: LetterMasters = {
  commands: ["M","V","H","V","H","V","H","V","H","Z"],
  narrowTall: [64,16,0,0,1024,64,1008,16,16,64],
  wideShort: [1024,16,0,0,64,1024,48,16,16,1024],
  narrowArtboard: [64, 1024],
  wideArtboard: [1024, 64],
  minAspect: 0.0625,
  maxAspect: 16,
  linkedPairs: [{"source":0,"target":5},{"source":0,"target":9},{"source":1,"target":8}],
}
